const deepFreeze = value => {
	if (!value || typeof value !== "object") return value;

	Object.freeze(value);
	Object.values(value).forEach(deepFreeze);
	return value;
};

const testIds = deepFreeze({
	app: {
		loading: {
			state: {
				suspenseLoader: "app.loading.state.suspense-loader",
			},
		},
		session: {
			modal: {
				container: "app.session.modal.container",
			},
			actions: {
				stayConnectedButton: "app.session.actions.stay-connected-button",
				logoutButton: "app.session.actions.logout-button",
			},
		},
	},
	shared: {
		buttonBar: {
			actions: {
				primaryButton: "shared.button-bar.actions.primary-button",
				secondaryButton: "shared.button-bar.actions.secondary-button",
			},
		},
	},
	auth: {
		login: {
			page: {
				container: "auth.login.page.container",
			},
			form: {
				container: "auth.login.form.container",
				trnInput: "auth.login.form.trn-input",
				dobMonthSelect: "auth.login.form.dob-month-select",
				dobDaySelect: "auth.login.form.dob-day-select",
				dobYearSelect: "auth.login.form.dob-year-select",
				genderSelect: "auth.login.form.gender-select",
				companyNameInput: "auth.login.form.company-name-input",
				companyTrnInput: "auth.login.form.company-trn-input",
			},
			actions: {
				individualTabButton: "auth.login.actions.individual-tab-button",
				corporateTabButton: "auth.login.actions.corporate-tab-button",
				submitButton: "auth.login.actions.submit-button",
			},
		},
		otp: {
			page: {
				container: "auth.otp.page.container",
			},
			methods: {
				container: "auth.otp.methods.container",
				smsOption: "auth.otp.methods.sms-option",
				emailOption: "auth.otp.methods.email-option",
				otherOption: "auth.otp.methods.other-option",
			},
			form: {
				policyNumberInput: "auth.otp.form.policy-number-input",
				chassisNumberInput: "auth.otp.form.chassis-number-input",
				licenseNumberInput: "auth.otp.form.license-number-input",
			},
			actions: {
				sendCodeButton: "auth.otp.actions.send-code-button",
				submitVerificationButton: "auth.otp.actions.submit-verification-button",
			},
		},
		otpVerification: {
			page: {
				container: "auth.otp-verification.page.container",
			},
			form: {
				container: "auth.otp-verification.form.container",
				codeInput: "auth.otp-verification.form.code-input",
			},
			state: {
				timer: "auth.otp-verification.state.timer",
			},
			actions: {
				verifyButton: "auth.otp-verification.actions.verify-button",
				resendButton: "auth.otp-verification.actions.resend-button",
				changeMethodLink: "auth.otp-verification.actions.change-method-link",
				requestNewCodeLink: "auth.otp-verification.actions.request-new-code-link",
			},
		},
		state: {
			fullLoginIndicator: "auth.state.full-login-indicator",
			accountLockedIndicator: "auth.state.account-locked-indicator",
		},
	},
	notifications: {
		toast: {
			container: "notifications.toast.container",
		},
	},
	navigation: {
		header: {
			container: "navigation.header.container",
			brandLink: "navigation.header.brand-link",
			searchInput: "navigation.header.search-input",
			searchButton: "navigation.header.search-button",
			agentLoginLink: "navigation.header.agent-login-link",
			actions: {
				renewPayButton: "navigation.header.actions.renew-pay-button",
				quoteBuyButton: "navigation.header.actions.quote-buy-button",
				reportClaimButton: "navigation.header.actions.report-claim-button",
				mobileMenuToggle: "navigation.header.actions.mobile-menu-toggle",
			},
		},
		headerUat: {
			container: "navigation.header-uat.container",
			brandLink: "navigation.header-uat.brand-link",
			searchInput: "navigation.header-uat.search-input",
			searchButton: "navigation.header-uat.search-button",
			agentLoginLink: "navigation.header-uat.agent-login-link",
			actions: {
				mobileMenuToggle: "navigation.header-uat.actions.mobile-menu-toggle",
				renewPayButton: "navigation.header-uat.actions.renew-pay-button",
				quoteBuyButton: "navigation.header-uat.actions.quote-buy-button",
				reportClaimButton: "navigation.header-uat.actions.report-claim-button",
			},
		},
		sidebar: {
			container: "navigation.sidebar.container",
			profile: {
				container: "navigation.sidebar.profile.container",
			},
			nav: {
				mainMenuLink: "navigation.sidebar.nav.main-menu-link",
				vehicleInformationLink: "navigation.sidebar.nav.vehicle-information-link",
				customerInformationLink: "navigation.sidebar.nav.customer-information-link",
				driverInformationLink: "navigation.sidebar.nav.driver-information-link",
				documentsCenterLink: "navigation.sidebar.nav.documents-center-link",
				paymentHistoryLink: "navigation.sidebar.nav.payment-history-link",
				myPoliciesLink: "navigation.sidebar.nav.my-policies-link",
				policyDetailsLink: "navigation.sidebar.nav.policy-details-link",
				renewalQuestionsLink: "navigation.sidebar.nav.renewal-questions-link",
				averageClauseLink: "navigation.sidebar.nav.average-clause-link",
				addBenefitsLink: "navigation.sidebar.nav.add-benefits-link",
				paymentOptionsLink: "navigation.sidebar.nav.payment-options-link",
				paymentPlanBreakdownLink: "navigation.sidebar.nav.payment-plan-breakdown-link",
				paymentLink: "navigation.sidebar.nav.payment-link",
				successLink: "navigation.sidebar.nav.success-link",
				paymentScheduleLink: "navigation.sidebar.nav.payment-schedule-link",
				noLossDeclarationLink: "navigation.sidebar.nav.no-loss-declaration-link",
				typeOfAccidentLink: "navigation.sidebar.nav.type-of-accident-link",
				selectVehicleLink: "navigation.sidebar.nav.select-vehicle-link",
				accidentDetailsLink: "navigation.sidebar.nav.accident-details-link",
				selectRepairerLink: "navigation.sidebar.nav.select-repairer-link",
				reviewClaimLink: "navigation.sidebar.nav.review-claim-link",
				claimsSubmittedLink: "navigation.sidebar.nav.claims-submitted-link",
			},
			footer: {
				uploadDocumentsLink: "navigation.sidebar.footer.upload-documents-link",
				notificationCenterLink: "navigation.sidebar.footer.notification-center-link",
				logoutButton: "navigation.sidebar.footer.logout-button",
			},
			modal: {
				discardChangesContainer: "navigation.sidebar.modal.discard-changes-container",
				discardChangesConfirmButton: "navigation.sidebar.modal.discard-changes-confirm-button",
				discardChangesCancelButton: "navigation.sidebar.modal.discard-changes-cancel-button",
				signOutContainer: "navigation.sidebar.modal.sign-out-container",
				signOutConfirmButton: "navigation.sidebar.modal.sign-out-confirm-button",
				signOutCancelButton: "navigation.sidebar.modal.sign-out-cancel-button",
			},
		},
	},
	contactInfo: {
		page: {
			container: "contact-info.page.container",
		},
		form: {
			container: "contact-info.form.container",
			emailInput: "contact-info.form.email-input",
		},
		state: {
			personalDetailHeading: "contact-info.state.personal-detail-heading",
		},
		actions: {
			confirmButton: "contact-info.actions.confirm-button",
			saveChangesButton: "contact-info.actions.save-changes-button",
			continueButton: "contact-info.actions.continue-button",
		},
	},
	paymentsLanding: {
		page: {
			container: "payments-landing.page.container",
		},
		actions: {
			renewNowButton: "payments-landing.actions.renew-now-button",
			payBalanceButton: "payments-landing.actions.pay-balance-button",
			quickPayButton: "payments-landing.actions.quick-pay-button",
		},
	},
	claimsLanding: {
		quick: {
			page: {
				container: "claims-landing.quick.page.container",
			},
			actions: {
				reportClaimButton: "claims-landing.quick.actions.report-claim-button",
				uploadDocumentsButton: "claims-landing.quick.actions.upload-documents-button",
				trackClaimButton: "claims-landing.quick.actions.track-claim-button",
			},
		},
	},
	quoteAndBuyLanding: {
		page: {
			container: "quote-and-buy-landing.page.container",
		},
		actions: {
			retrieveQuoteButton: "quote-and-buy-landing.actions.retrieve-quote-button",
			getQuoteButton: "quote-and-buy-landing.actions.get-quote-button",
		},
	},
	policyListing: {
		page: {
			container: "policy-listing.page.container",
		},
		tabs: {
			motorTab: "policy-listing.tabs.motor-tab",
			homeTab: "policy-listing.tabs.home-tab",
			liabilityTab: "policy-listing.tabs.liability-tab",
		},
		policy: {
			actions: {
				selectButton: "policy-listing.policy.actions.select-button",
			},
		},
	},
	policyManager: {
		policyListing: {
			page: {
				container: "policy-manager.policy-listing.page.container",
			},
		},
		editor: {
			page: {
				container: "policy-manager.editor.page.container",
			},
			menu: {
				actions: {
					updatePersonalInfoButton: "policy-manager.editor.menu.actions.update-personal-info-button",
					manageVehicleInfoButton: "policy-manager.editor.menu.actions.manage-vehicle-info-button",
					manageDriversButton: "policy-manager.editor.menu.actions.manage-drivers-button",
					documentsCenterButton: "policy-manager.editor.menu.actions.documents-center-button",
					paymentHistoryButton: "policy-manager.editor.menu.actions.payment-history-button",
				},
			},
		},
		vehicleManagement: {
			page: {
				container: "policy-manager.vehicle-management.page.container",
			},
			actions: {
				addVehicleButton: "policy-manager.vehicle-management.actions.add-vehicle-button",
				changeVehicleButton: "policy-manager.vehicle-management.actions.change-vehicle-button",
				deleteVehicleButton: "policy-manager.vehicle-management.actions.delete-vehicle-button",
				backButton: "policy-manager.vehicle-management.actions.back-button",
			},
		},
		paymentSummary: {
			page: {
				container: "policy-manager.payment-summary.page.container",
			},
			actions: {
				backButton: "policy-manager.payment-summary.actions.back-button",
				continueButton: "policy-manager.payment-summary.actions.continue-button",
			},
		},
		documentsCenter: {
			page: {
				container: "policy-manager.documents-center.page.container",
			},
			tabs: {
				motorTab: "policy-manager.documents-center.tabs.motor-tab",
				homeTab: "policy-manager.documents-center.tabs.home-tab",
			},
		},
		paymentHistory: {
			page: {
				container: "policy-manager.payment-history.page.container",
			},
			actions: {
				openFilterButton: "policy-manager.payment-history.actions.open-filter-button",
			},
		},
		uploadDocuments: {
			page: {
				container: "policy-manager.upload-documents.page.container",
			},
		},
	},
	renewal: {
		policyListing: {
			page: {
				container: "renewal.policy-listing.page.container",
			},
			state: {
				advertContainer: "renewal.policy-listing.state.advert-container",
				myPoliciesHeading: "renewal.policy-listing.state.my-policies-heading",
			},
		},
		policyDetails: {
			page: {
				container: "renewal.policy-details.page.container",
			},
			state: {
				renewalOptions: "renewal.policy-details.state.renewal-options",
				policyNumber: "renewal.policy-details.state.policy-number",
				policyType: "renewal.policy-details.state.policy-type",
				coverageAmount: "renewal.policy-details.state.coverage-amount",
			},
			actions: {
				backButton: "renewal.policy-details.actions.back-button",
				continueButton: "renewal.policy-details.actions.continue-button",
				renewButton: "renewal.policy-details.actions.renew-button",
			},
		},
		questions: {
			page: {
				container: "renewal.questions.page.container",
			},
			form: {
				questionsGroupAuto: "renewal.questions.form.questions-auto",
				questionsGroupHome: "renewal.questions.form.questions-home",
				agreeCheckbox: "renewal.questions.form.agree-checkbox",
			},
			actions: {
				backButton: "renewal.questions.actions.back-button",
				continueButton: "renewal.questions.actions.continue-button",
			},
		},
		averageClause: {
			page: {
				container: "renewal.average-clause.page.container",
			},
			actions: {
				continueButton: "renewal.average-clause.actions.continue-button",
			},
		},
		benefits: {
			page: {
				container: "renewal.benefits.page.container",
			},
			form: {
				promoCodeInput: "renewal.benefits.form.promo-code-input",
			},
			state: {
				benefitsCount: "renewal.benefits.state.benefits-count",
				totalCost: "renewal.benefits.state.total-cost",
				newBenefit: "renewal.benefits.state.new-benefit",
			},
			actions: {
				viewCartButton: "renewal.benefits.actions.view-cart-button",
				updateCartButton: "renewal.benefits.actions.update-cart-button",
				continueButton: "renewal.benefits.actions.continue-button",
				proceedToPaymentButton: "renewal.benefits.actions.proceed-to-payment-button",
			},
		},
		cart: {
			page: {
				container: "renewal.cart.page.container",
			},
			actions: {
				backButton: "renewal.cart.actions.back-button",
				confirmButton: "renewal.cart.actions.confirm-button",
			},
		},
		paymentOption: {
			page: {
				container: "renewal.payment-option.page.container",
			},
			state: {
				paymentPlans: "renewal.payment-option.state.payment-plans",
			},
			actions: {
				backButton: "renewal.payment-option.actions.back-button",
				continueButton: "renewal.payment-option.actions.continue-button",
			},
		},
		paymentPlanBreakdown: {
			page: {
				container: "renewal.payment-plan-breakdown.page.container",
			},
			state: {
				planDetails: "renewal.payment-plan-breakdown.state.plan-details",
				planName: "renewal.payment-plan-breakdown.state.plan-name",
				frequency: "renewal.payment-plan-breakdown.state.frequency",
				amount: "renewal.payment-plan-breakdown.state.amount",
				savings: "renewal.payment-plan-breakdown.state.savings",
			},
			actions: {
				cancelButton: "renewal.payment-plan-breakdown.actions.cancel-button",
				submitButton: "renewal.payment-plan-breakdown.actions.submit-button",
			},
		},
		paymentMethod: {
			page: {
				container: "renewal.payment-method.page.container",
			},
			methods: {
				branchOption: "renewal.payment-method.methods.branch-option",
				cardOption: "renewal.payment-method.methods.card-option",
			},
			modal: {
				branchConfirmContainer: "renewal.payment-method.modal.branch-confirm-container",
				branchConfirmButton: "renewal.payment-method.modal.branch-confirm-button",
				branchCancelButton: "renewal.payment-method.modal.branch-cancel-button",
			},
			actions: {
				backButton: "renewal.payment-method.actions.back-button",
			},
		},
		cashPayment: {
			branchPage: {
				container: "renewal.cash-payment.branch-page.container",
			},
			form: {
				branchSelect: "renewal.cash-payment.form.branch-select",
			},
			state: {
				branchInstructions: "renewal.cash-payment.state.branch-instructions",
				branchContact: "renewal.cash-payment.state.branch-contact",
			},
			actions: {
				submitButton: "renewal.cash-payment.actions.submit-button",
			},
		},
		cardPayment: {
			page: {
				container: "renewal.card-payment.page.container",
			},
			form: {
				container: "renewal.card-payment.form.container",
				cardNumberInput: "renewal.card-payment.form.card-number-input",
				cardholderNameInput: "renewal.card-payment.form.cardholder-name-input",
				expiryDateInput: "renewal.card-payment.form.expiry-date-input",
				cvvInput: "renewal.card-payment.form.cvv-input",
				useHomeAddressCheckbox: "renewal.card-payment.form.use-home-address-checkbox",
			},
			modal: {
				confirmationContainer: "renewal.card-payment.modal.confirmation-container",
				acceptButton: "renewal.card-payment.modal.accept-button",
				cancelButton: "renewal.card-payment.modal.cancel-button",
				maskedCardEnding: "renewal.card-payment.modal.masked-card-ending",
				paymentAmount: "renewal.card-payment.modal.payment-amount",
			},
			actions: {
				payNowButton: "renewal.card-payment.actions.pay-now-button",
			},
			state: {
				paymentProcessed: "renewal.card-payment.state.payment-processed",
				policyRenewed: "renewal.card-payment.state.policy-renewed",
			},
		},
		paymentSuccess: {
			page: {
				container: "renewal.payment-success.page.container",
			},
			state: {
				toastNotification: "renewal.payment-success.state.toast-notification",
				renewalPeriod: "renewal.payment-success.state.renewal-period",
				paymentReference: "renewal.payment-success.state.payment-reference",
			},
			actions: {
				downloadPolicyDocumentsButton: "renewal.payment-success.actions.download-policy-documents-button",
				printButton: "renewal.payment-success.actions.print-button",
				emailButton: "renewal.payment-success.actions.email-button",
			},
		},
		payment: {
			page: {
				container: "renewal.payment.page.container",
			},
		},
		confirmAgreement: {
			page: {
				container: "renewal.confirm-agreement.page.container",
			},
			actions: {
				backButton: "renewal.confirm-agreement.actions.back-button",
			},
		},
		quotesListing: {
			page: {
				container: "renewal.quotes-listing.page.container",
			},
			actions: {
				backButton: "renewal.quotes-listing.actions.back-button",
			},
		},
		uploadOutstandingDocument: {
			page: {
				container: "renewal.upload-outstanding-document.page.container",
			},
			actions: {
				backButton: "renewal.upload-outstanding-document.actions.back-button",
				submitButton: "renewal.upload-outstanding-document.actions.submit-button",
			},
		},
	},
	payBalance: {
		policyListing: {
			page: {
				container: "pay-balance.policy-listing.page.container",
			},
		},
		paymentSchedule: {
			page: {
				container: "pay-balance.payment-schedule.page.container",
			},
			actions: {
				backButton: "pay-balance.payment-schedule.actions.back-button",
				continueButton: "pay-balance.payment-schedule.actions.continue-button",
			},
		},
		noLossDeclaration: {
			page: {
				container: "pay-balance.no-loss-declaration.page.container",
			},
			actions: {
				agreeButton: "pay-balance.no-loss-declaration.actions.agree-button",
			},
		},
		payment: {
			page: {
				container: "pay-balance.payment.page.container",
			},
		},
		uploadOutstandingDocument: {
			page: {
				container: "pay-balance.upload-outstanding-document.page.container",
			},
			actions: {
				backButton: "pay-balance.upload-outstanding-document.actions.back-button",
				submitButton: "pay-balance.upload-outstanding-document.actions.submit-button",
			},
		},
	},
	claims: {
		accidentType: {
			page: {
				container: "claims.accident-type.page.container",
			},
			tabs: {
				autoTab: "claims.accident-type.tabs.auto-tab",
				homeTab: "claims.accident-type.tabs.home-tab",
			},
		},
		accidentDateTimeLocation: {
			page: {
				container: "claims.accident-date-time-location.page.container",
			},
			actions: {
				backButton: "claims.accident-date-time-location.actions.back-button",
				nextButton: "claims.accident-date-time-location.actions.next-button",
			},
		},
		driverInfo: {
			page: {
				container: "claims.driver-info.page.container",
			},
			actions: {
				backButton: "claims.driver-info.actions.back-button",
				nextButton: "claims.driver-info.actions.next-button",
			},
		},
		accidentDetails: {
			page: {
				container: "claims.accident-details.page.container",
			},
			actions: {
				backButton: "claims.accident-details.actions.back-button",
				continueButton: "claims.accident-details.actions.continue-button",
			},
		},
		serviceProviders: {
			page: {
				container: "claims.service-providers.page.container",
			},
			actions: {
				backButton: "claims.service-providers.actions.back-button",
				reviewButton: "claims.service-providers.actions.review-button",
			},
		},
		resultedIn: {
			page: {
				container: "claims.resulted-in.page.container",
			},
			actions: {
				backButton: "claims.resulted-in.actions.back-button",
				nextButton: "claims.resulted-in.actions.next-button",
			},
		},
		accidentVehicleDamage: {
			page: {
				container: "claims.accident-vehicle-damage.page.container",
			},
			actions: {
				backButton: "claims.accident-vehicle-damage.actions.back-button",
				nextButton: "claims.accident-vehicle-damage.actions.next-button",
			},
		},
		policeReport: {
			page: {
				container: "claims.police-report.page.container",
			},
			actions: {
				backButton: "claims.police-report.actions.back-button",
				nextButton: "claims.police-report.actions.next-button",
			},
		},
		passengerDetails: {
			page: {
				container: "claims.passenger-details.page.container",
			},
			actions: {
				backButton: "claims.passenger-details.actions.back-button",
				nextButton: "claims.passenger-details.actions.next-button",
			},
		},
		resultedInWindscreen: {
			page: {
				container: "claims.resulted-in-windscreen.page.container",
			},
			actions: {
				backButton: "claims.resulted-in-windscreen.actions.back-button",
				continueButton: "claims.resulted-in-windscreen.actions.continue-button",
			},
		},
		causeOfDamage: {
			page: {
				container: "claims.cause-of-damage.page.container",
			},
			actions: {
				backButton: "claims.cause-of-damage.actions.back-button",
				continueButton: "claims.cause-of-damage.actions.continue-button",
			},
		},
		accidentDetailsInsured: {
			page: {
				container: "claims.accident-details-insured.page.container",
			},
			actions: {
				backButton: "claims.accident-details-insured.actions.back-button",
				nextButton: "claims.accident-details-insured.actions.next-button",
			},
		},
		accidentDetailsThirdParty: {
			page: {
				container: "claims.accident-details-third-party.page.container",
			},
			actions: {
				backButton: "claims.accident-details-third-party.actions.back-button",
				nextButton: "claims.accident-details-third-party.actions.next-button",
			},
		},
		uploadDocuments: {
			page: {
				container: "claims.upload-documents.page.container",
			},
			actions: {
				nextButton: "claims.upload-documents.actions.next-button",
			},
		},
		policyListing: {
			page: {
				container: "claims.policy-listing.page.container",
			},
		},
		claimReview: {
			page: {
				container: "claims.claim-review.page.container",
			},
			actions: {
				backButton: "claims.claim-review.actions.back-button",
				submitButton: "claims.claim-review.actions.submit-button",
			},
		},
		success: {
			page: {
				container: "claims.success.page.container",
			},
			actions: {
				downloadButton: "claims.success.actions.download-button",
				trackClaimButton: "claims.success.actions.track-claim-button",
			},
		},
	},
	trackClaim: {
		claimListing: {
			page: {
				container: "track-claim.claim-listing.page.container",
			},
			form: {
				searchInput: "track-claim.claim-listing.form.search-input",
			},
			actions: {
				filterButton: "track-claim.claim-listing.actions.filter-button",
			},
			filters: {
				policySelect: "track-claim.claim-listing.filters.policy-select",
				riskSelect: "track-claim.claim-listing.filters.risk-select",
				statusSelect: "track-claim.claim-listing.filters.status-select",
			},
		},
		menu: {
			page: {
				container: "track-claim.menu.page.container",
			},
			actions: {
				trackClaimButton: "track-claim.menu.actions.track-claim-button",
				claimPaymentsButton: "track-claim.menu.actions.claim-payments-button",
				documentUploadButton: "track-claim.menu.actions.document-upload-button",
				claimRequestButton: "track-claim.menu.actions.claim-request-button",
			},
		},
		claimDetails: {
			page: {
				container: "track-claim.claim-details.page.container",
			},
			actions: {
				backButton: "track-claim.claim-details.actions.back-button",
				sendRequestButton: "track-claim.claim-details.actions.send-request-button",
			},
		},
		claimRequest: {
			page: {
				container: "track-claim.claim-request.page.container",
			},
			actions: {
				backButton: "track-claim.claim-request.actions.back-button",
				submitButton: "track-claim.claim-request.actions.submit-button",
			},
		},
		documentUpload: {
			page: {
				container: "track-claim.document-upload.page.container",
			},
			actions: {
				backButton: "track-claim.document-upload.actions.back-button",
				submitButton: "track-claim.document-upload.actions.submit-button",
			},
		},
	},
});

const flattenTestIds = (source, prefix = "", target = {}) => {
	Object.entries(source).forEach(([key, value]) => {
		const path = prefix ? `${prefix}.${key}` : key;

		if (typeof value === "string") {
			target[path] = value;
			return;
		}

		flattenTestIds(value, path, target);
	});

	return target;
};

const flatTestIds = deepFreeze(flattenTestIds(testIds));

export { testIds, flatTestIds, flattenTestIds };
